import { Typography } from '@material-ui/core'
import React, { useState } from 'react'

import useStyles from './styles'

const ContactForm = () => {
  const {
    center,
    formControl,
    submit,
    labelClass,
    submitWrapper,
    errorMessage,
    successMessage,
  } = useStyles()
  const [status, setStatus] = useState('')

  const submitForm = (ev) => {
    console.log('ola')
    ev.preventDefault()
    const form = ev.target
    const data = new FormData(form)
    const xhr = new XMLHttpRequest()
    xhr.open(form.method, form.action)
    xhr.setRequestHeader('Accept', 'application/json')
    xhr.onreadystatechange = () => {
      if (xhr.readyState !== XMLHttpRequest.DONE) return
      if (xhr.status === 200) {
        form.reset()
        setStatus('SUCCESS')
      } else {
        setStatus('ERROR')
      }
    }
    xhr.send(data)
  }

  return (
    <div className={center}>
      <form
        onSubmit={submitForm}
        action="https://formspree.io/juancarlos@jjaas.mx"
        method="POST"
      >
        <div>
          <label className={labelClass} htmlFor="name">
            Nombre
          </label>
          <input
            type="text"
            name="name"
            id="name"
            className={formControl}
            placeholder="María García"
          />
          <label className={labelClass} htmlFor="email">
            Correo electrónico
          </label>
          <input
            type="email"
            name="email"
            id="email"
            className={formControl}
            placeholder="maria@email.com"
          />
          <label className={labelClass} htmlFor="phone">
            Teléfono de contacto
          </label>
          <input
            type="phone"
            name="phone"
            id="phone"
            className={formControl}
            placeholder="número telefónico (10 dígitos)"
          />
          <label className={labelClass} htmlFor="message">
            ¿En qué podemos ayudarte?
          </label>
          <textarea
            name="message"
            id="message"
            rows="10"
            className={formControl}
          />
        </div>
        {status === 'SUCCESS' ? (
          <p className={successMessage}>
            ¡Gracias! Estaremos en contacto contigo.
          </p>
        ) : (
          <div className={submitWrapper}>
            <input type="submit" value="Enviar" className={submit} />
          </div>
        )}
        {status === 'ERROR' && (
          <Typography className={errorMessage}>
            Ooops! Parece que hubo un error.
          </Typography>
        )}
      </form>
    </div>
  )
}

export default ContactForm
